import {OrdineKey, OrdinePKey} from './Ordine';
import {StatoEnum} from './generated/stato-enum';
import {OrdineGroup} from './OrdineGroup';

/**
 * Una riga/fase a monte ancora aperta, come l'operatore la vede nell'elenco prima di confermare la
 * chiusura (issue #3477).
 *
 * ⚠️ `idDocumento` non è un campo di contorno: l'elenco può attraversare più ordini di produzione e
 * le voci vanno raggruppate per documento, altrimenti l'operatore non sa a quale ordine appartiene
 * ciò che sta chiudendo.
 */
export class FasePrecedenteAperta extends OrdinePKey {
  numFase?: number;
  codiceArticolo?: string;
  descArticolo?: string;
  codiceLavorazione?: string;
  descLavorazione?: string;
  codiceRisorsa?: string;
  /** Quantità ordinata. */
  quantita: number;
  /** Quantità lavorata: confrontata con l'ordinata è il dato principale della voce. */
  quantitaLavorata: number;
  quantitaScartata: number;
  udM?: string;
  /** Stato dell'ordine. */
  stato: StatoEnum;
  /**
   * Stato dell'ultimo invio — informazione distinta dallo stato dell'ordine, e servono entrambe:
   * una fase in lavorazione ha quasi sempre un invio appena partito.
   */
  statoUltimoInvio?: StatoEnum;
  /** Vero quando l'invio precedente è in corso o fallito: la fase verrà saltata dalla chiusura. */
  saraSaltata: boolean;
}

/** Una fase del gruppo di lavoro, usata come riferimento per calcolare un perimetro. */
export class FaseCorrenteRef {
  idDocumento: number;
  idRiga: number;
  idRigaLavorazione: number;
  numFase: number;
}

export enum EsitoChiusuraFaseEnum {
  Chiusa = 0,
  Saltata = 1,
  Errore = 2
}

export enum MotivoSaltoEnum {
  GiaTerminata = 0,
  InvioInCorso = 1,
  InvioFallito = 2,
  NonLeggibile = 3
}

/** Esito della chiusura di una singola fase precedente. */
export class EsitoChiusuraFase extends OrdinePKey {
  numFase?: number;
  esito: EsitoChiusuraFaseEnum;
  motivoSalto?: MotivoSaltoEnum;
  motivo?: string;
}

/** Risultato di un Termina con chiusura delle fasi precedenti. */
export class FineConPrecedentiResult {
  ordineGroup: OrdineGroup;
  precedenti: EsitoChiusuraFase[];
}

export type ChiaveFasePrecedente = OrdineKey;
